import { DocumentData, DocumentReference } from "@angular/fire/firestore";
import { OrderResponse } from "./order-response.model";

export class UserSummary {
  public readonly reference: DocumentReference;
  public readonly name: string;
  public readonly email: string;
  public readonly responses: OrderResponse[];
  constructor(data: DocumentData) {
    this.reference = data.reference as DocumentReference;
    this.name = data.name;
    this.email = data.email;
    this.responses =
      data.responses == null
        ? null
        : (data.responses as any[]).map(
            response => new OrderResponse(response.question, response.response)
          );
  }
}
